export default __webpack_public_path__ + "static/14-994dbd89313da8a36e06839352d4c861.png";